const authModule = "/auth";
const itemsModule = "/dashboard/items";
const categoriesModule = "/dashboard/categories";
const suppliersModule = "/dashboard/suppliers";
const purchaseOrdersModule = "/dashboard/purchase-orders";
const itemVariations = "/dashboard/supplier-item-variations";
const inventoryModule = "/dashboard/item-variation-stocks";
const incomingRequestsModule = "/dashboard/incoming-requests";
const branchRequestsModule = "/dashboard/branch-request-prepared-item";
const transfersModule = "/dashboard/branch-transfer";
const ingredientsModule = "/dashboard/ingredients";
const preparedItemsModule = "/dashboard/prepared-items";
const produceOutputModule = "/dashboard/produce-output";
const ckPreparedItemRequestsModule = "/dashboard/ck-request-prepared-item";

export const Endpoints = {
  auth: {
    login: `${authModule}/login`,
  },
  items: {
    getHelperData: `${itemsModule}/help-data`,
    getAllItems: `${itemsModule}`,
    getItemById: (id: string | number) => `${itemsModule}/${id}`,
    deleteItems: `${itemsModule}/delete`,
    changeStatus: `${itemsModule}/change-status`,
    importItems: `${itemsModule}/import-items`,
    createItems: `${itemsModule}`,
    updateItems: (id: string | number) => `${itemsModule}/${id}`,
  },
  suppliers: {
    getAllSuppliers: `${suppliersModule}`,
    getSupplierById: (id: string | number) => `${suppliersModule}/${id}`,
    changeStatus: `${suppliersModule}/change-status`,
    getHelpData: `${suppliersModule}/help-data`,
    createSupplier: `${suppliersModule}`,
    updateSupplier: (id: string | number) => `${suppliersModule}/update/${id}`,
    deleteSuppliers: `${suppliersModule}/delete`,
    addSupplierItemVariation: `/dashboard/supplier-item-variations`,
  },
  purchaseOrders: {
    getAllPurchaseOrders: `${purchaseOrdersModule}`,
    getPurchaseOrderById: (id: string | number) =>
      `${purchaseOrdersModule}/${id}`,
    getHelpData: `${purchaseOrdersModule}/help-data`,
    changeStatus: (id: string | number) =>
      `${purchaseOrdersModule}/change-status-canceled/${id}`,
    deletePurchaseOrders: `${purchaseOrdersModule}/delete`,
    getCategories_items: (id: string | number) =>
      `${itemVariations}/categories-items/${id}`,
    getItemVariations: `${itemVariations}/items-variation-item-ids`,
    createPurchaseOrder: `${purchaseOrdersModule}`,
    addItemVariation: `${itemVariations}`,
    updateReceiver: (id: string | number) =>
      `${purchaseOrdersModule}/update-receiver/${id}`,
  },
  inventory: {
    getLiveInventory: `${inventoryModule}/inventory`,
    getHelpData: `${inventoryModule}/inventory/help-data`,
    getHelpDataMovementHistory: `${inventoryModule}/inventory/help-data-movement-history`,
    getOpeningBalance: `${inventoryModule}/inventory/view-opening-balance`,
    getAllItems: `${inventoryModule}`,
    setOpeningBalance: `${inventoryModule}/add-opening-balance`,
    deleteOpeningBalanceDraft: `${inventoryModule}/delete-opening-balance-draft`,
    getStockDetails: (id: string | number) => `${inventoryModule}/inventory/show-item-stock-details/${id}`,
    getMovementHistory: `${inventoryModule}/inventory/index-movement-history`,
  },
  incomingRequests: {
    getIncomingRequests: `${incomingRequestsModule}/incoming-requests`,
    getIncomingRequestById: (id: string | number) =>
      `${incomingRequestsModule}/incoming-requests/${id}`,
    getTransferLocations: `${incomingRequestsModule}/locations`,
  },
  branchRequests: {
    getBranchRequests: branchRequestsModule,
    getBranchRequestById: (id: string | number) => `${branchRequestsModule}/${id}`,
    getHelpData: `${branchRequestsModule}/help-data`,
    getItemsDetails: `${branchRequestsModule}/items-details`,
    createBranchRequest: branchRequestsModule,
    updateBranchRequest: (id: string | number) => `${branchRequestsModule}/${id}`,
    cancelRequest: (id: string | number) =>
      `${branchRequestsModule}/cancel-request/${id}`,
  },
  draft: {
    showDraft: `${itemsModule}/show-batch-draft`,
    updateDraft: `${itemsModule}/update-batch-draft`,
    showSupplierDraft: `${suppliersModule}/show-batch-draft`,
    updateSupplierDraft: `${suppliersModule}/update`,
    updatePODraft: `${purchaseOrdersModule}/update`,
    showPreparedItemsDraft: `${preparedItemsModule}/show-batch-draft`,
    updatePreparedItemsDraft: `${preparedItemsModule}/update-batch-draft`,
  },
  categories: {
    getCategories: `${categoriesModule}/index-tree`,
  },
  transfers: {
    getHelpData: `${transfersModule}/help-data`,
    changeTransferStatus: (id: string | number) =>
      `${transfersModule}/change-status-canceled/${id}`,
    getMyTransfersIn: `${transfersModule}/my-transfer-in`,
    getMyTransferInById: (id: string | number) => `${transfersModule}/my-transfer-in/${id}`,
    receiveTransfer: (id: string | number) => `${transfersModule}/receive-transfer/${id}`,
    getItemsDetails: `${transfersModule}/items-details`,
    createTransfer: `${transfersModule}/store`,
    showDraft: `${transfersModule}/show-draft`,
    getMyTransfersOut: `${transfersModule}/my-transfer-out`,
    getMyTransferOutById: (id: string | number) => `${transfersModule}/my-transfer-out/${id}`,
    deleteDraft: `${transfersModule}/delete-draft`,

  },
  ingredients: {
    getHelpData: `${ingredientsModule}/help-data`,
    setup: ingredientsModule,
    showDraft: (id: string | number) => `${ingredientsModule}/show-draft/${id}`,
    deleteDraft: (id: string | number) =>
      `${ingredientsModule}/delete-draft/${id}`,
    updateBatchDraft: (id: string | number) =>
      `${ingredientsModule}/update-batch-draft/${id}`,
    getItemsByIds: `${ingredientsModule}/items-item-ids`,
  },
  preparedItems: {
    getById: (id: string | number) => `${preparedItemsModule}/${id}`,
    updatePreparedItem: (id: string | number) => `${preparedItemsModule}/update/${id}`,
    changeStatus: `${preparedItemsModule}/change-status`,
    getAllPreparedItems: `${preparedItemsModule}`,
    getHelperData: `${preparedItemsModule}/help-data`,
    deletePreparedItems: `${preparedItemsModule}/delete`,
    createPreparedItems: `${preparedItemsModule}`,
    importPreparedItems: `${preparedItemsModule}/import-items`,
  },
  produceOutput: {
    getAll: `${produceOutputModule}`,
    create: `${produceOutputModule}`,
    getHelperData: `${produceOutputModule}/help-data`,
    showPreparedItem: (id: string | number) =>
      `${produceOutputModule}/show-prepared-item/${id}`,
    showProduceOutputById: (id: string | number) =>
      `${produceOutputModule}/${id}`,
    showPendingRecord: (id: string | number) =>
      `${produceOutputModule}/show-pending-record-output/${id}`,
    storeRecordOutput: (id: string | number) =>
      `${produceOutputModule}/store-record-output/${id}`,
  },
  ckPreparedItemRequests: {
    getHelpData: `${ckPreparedItemRequestsModule}/help-data`,
    indexBranchPlans: `${ckPreparedItemRequestsModule}/index-branch-plans`,
    indexAggregatedItems: `${ckPreparedItemRequestsModule}/index-aggregated-items`,
    showAggregatedItem: (id: string | number) =>
      `${ckPreparedItemRequestsModule}/show-aggregated-item/${id}`,
    confirmQtyPreparedItems: `${ckPreparedItemRequestsModule}/confirm-qty-prepared-items`,
    sendItems: (id: string | number) =>
      `${ckPreparedItemRequestsModule}/send-items/${id}`,
    getRequestDetails: (id: string | number) =>
      `${ckPreparedItemRequestsModule}/show-request-details/${id}`,
    showSentAggregatedItemDetails: (id: string | number) =>
      `${ckPreparedItemRequestsModule}/show-sent-aggregated-item-details/${id}`,
    rejectRequest: (id: string | number) =>
      `${ckPreparedItemRequestsModule}/reject-request/${id}`,
  },
};
